import { HttpParams } from "@angular/common/http";

export class HttpUtils {

  public static objectToHttpParams(obj: any): HttpParams {
    let params = new HttpParams();

    Object.keys(obj).forEach(key => {
      const value = obj[key];
      
      if (value !== null && value !== undefined) {
        if (Array.isArray(value)) {
          value.forEach(item => {
            params = params.append(key, item.toString());
          });
        } else {
          params = params.append(key, value.toString());
        }
      }
    });

    return params;
  }
}